{
  "list": {
    "intro": "Pages that group products on the shop, like \"Pokémon Rank A\" or \"New arrivals\".",
    "new": "New collection",
    "search": "Search collections",
    "show_trash": "Show deleted (30 days)",
    "empty": "No collections yet",
    "empty_hint": "Make one by choosing cards yourself, or by rules.",
    "trash_empty": "Nothing deleted in the last 30 days",
    "label": "Collections",
    "type_manual": "Chosen by hand",
    "type_smart": "By rules",
    "count_one": "{{count}} product",
    "count_other": "{{count}} products",
    "published": "Shown on the shop",
    "hidden": "Hidden",
    "restore": "Put back",
    "restored": "\"{{title}}\" is back"
  },
  "new": {
    "title": "What kind of collection?",
    "hint": "You can change the products later, but not the kind.",
    "manual": "I choose the cards",
    "manual_hint": "Search, add and put the cards in the order you want.",
    "smart": "By rules",
    "smart_hint": "For example: Pokémon · Rank A · price at least ¥10,000 — new cards join by themselves."
  },
  "edit": {
    "new_manual": "New collection (chosen by hand)",
    "new_smart": "New collection (by rules)",
    "untitled": "Collection",
    "manual_intro": "Add cards and drag them into order. Nothing is sent until you press Save.",
    "smart_intro": "Products that match the rules join by themselves. The count below comes from the system.",
    "basics": "Name and description",
    "title_label": "Name",
    "title_required": "Give the collection a name",
    "description_label": "Description",
    "description_hint": "Shown at the top of the collection page. A blank line starts a new paragraph.",
    "publish_now": "Show it on the shop right away",
    "products_title": "Products and their order",
    "rules_title": "Rules",
    "sort_label": "Order on the shop",
    "sort_hint": "How customers see the products",
    "sort": {
      "manual": "The order I set",
      "created_desc": "Newest first",
      "price_asc": "Cheapest first",
      "price_desc": "Most expensive first",
      "title_asc": "Name A → Z",
      "title_desc": "Name Z → A",
      "best_selling": "Best-selling first"
    },
    "pictures": "Pictures",
    "hero_desktop": "Top picture (computer)",
    "hero_mobile": "Top picture (phone)",
    "languages": "Name and description in other languages",
    "layout_label": "Page layout",
    "layout_hint": "Leave empty for the standard layout",
    "create": "Create the collection",
    "save": "Save",
    "saved": "\"{{title}}\" saved",
    "show": "Show on the shop",
    "hide": "Hide from the shop",
    "now_shown": "Shown on the shop",
    "now_hidden": "Hidden from the shop",
    "delete": "Delete",
    "delete_title": "Delete this collection?",
    "delete_consequence": "The page disappears from the shop. The products stay. You can put it back within 30 days.",
    "deleted": "Collection deleted"
  },
  "manual": {
    "add_label": "Add products",
    "search_placeholder": "Name, product code or certificate number",
    "results": "Search results",
    "no_results": "Nothing found",
    "add": "Add",
    "add_named": "Add {{title}}",
    "inside": "Added",
    "empty": "No products yet — search above and press Add.",
    "order_hint": "Drag ⠿, use ▲ ▼, or pick up with Space and move with the arrow keys.",
    "list_label": "Products in this collection",
    "remove": "Remove {{title}}",
    "removed": "\"{{title}}\" removed",
    "loading": "Loading…"
  },
  "rules": {
    "match_legend": "Products must match",
    "match": {
      "all": "All the rules",
      "any": "Any one rule"
    },
    "list_label": "Rules",
    "row_label": "Rule {{n}}",
    "field_label": "What (rule {{n}})",
    "op_label": "How (rule {{n}})",
    "pick_field": "Choose…",
    "remove": "Remove rule {{n}}",
    "add": "Add a rule",
    "and": "and",
    "from": "From",
    "to": "To",
    "relative": "in the last … days",
    "days_placeholder": "Number of days",
    "set_placeholder": "Set code, e.g. SV2a",
    "list_placeholder": "Values separated by commas",
    "attribute": "Extra detail: {{name}}",
    "fields": {
      "game": "Game",
      "set": "Set",
      "product_type": "Kind",
      "raw_rank": "Rank (A–D, cards)",
      "grading_company": "Grading company",
      "grade": "Grade (graded cards)",
      "price": "Price (¥, tax incl.)",
      "tag": "Tag",
      "category": "Category",
      "vendor": "Maker",
      "rarity": "Rarity",
      "language": "Card language",
      "availability": "In stock",
      "status": "Status",
      "created_at": "Added on",
      "published_at": "Put on sale on",
      "consignor": "Consigned",
      "title": "Name",
      "condition_type": "Card or graded or sealed",
      "compare_at_status": "Reference price checked"
    },
    "ops": {
      "eq": "is",
      "neq": "is not",
      "in": "is one of",
      "not_in": "is none of",
      "contains": "contains",
      "starts_with": "starts with",
      "gt": "more than",
      "gte": "at least",
      "lt": "less than",
      "lte": "at most",
      "between": "between",
      "is_true": "yes",
      "is_false": "no"
    },
    "ops_date": {
      "gt": "after",
      "gte": "on or after",
      "lt": "before",
      "lte": "on or before"
    },
    "ops_availability": {
      "is_true": "in stock",
      "is_false": "sold out"
    },
    "ops_consignor": {
      "is_true": "is a consigned card",
      "is_false": "is the shop's own card"
    },
    "status": {
      "active": "On sale",
      "draft": "Draft",
      "archived": "Archived"
    },
    "condition": {
      "raw": "Card",
      "graded": "Graded card",
      "sealed": "Sealed"
    },
    "compare_at": {
      "verified": "Checked",
      "unverified": "Not checked"
    },
    "problem": {
      "field_required": "Choose what to check",
      "operator_required": "Choose how to check it",
      "value_required": "Fill in the value",
      "value_invalid": "This value does not fit — check it",
      "invalid": "The system cannot use this rule — check it",
      "unknown_field": "This kind of rule is not available",
      "operator_not_allowed": "This \"how\" does not fit the \"what\"",
      "field_not_enabled": "Not available yet"
    }
  },
  "preview": {
    "title": "Products that match now",
    "waiting": "Complete a rule to see the count.",
    "counting": "Counting…",
    "count_one": "{{count}} product matches",
    "count_other": "{{count}} products match",
    "error": "The count could not be made. Try again.",
    "fix_rows": "Some rules need fixing (marked in red)."
  }
}
